const eggForms = {
  none: 1,
  breedableEggs: 2,
  nonBreedableEggs: 3,

  isValidValue: (value) => Object.values(eggForms).includes(value) !== undefined
}

export default Object.freeze(eggForms)
